export default "__VITE_ASSET__$n6VPHhF__"